<template>
  <van-overlay :show="true">
    <div class="wrapper">
      <div class="block">
        <div class="title">关注公众号</div>
        <div class="qrCode">
          <img :src="codeImg" class="img" alt="">
        </div>
        <div class="desc">为了红包顺利发放,请<span style="color: red;">长按识别二维码</span>关注公众号,根据提示答卷。 </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  data() {
    return {
      codeImg: require('../assets/images/qrcode.jpg')
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isShow: {
      get() {
        console.log(this.show, '接受的show')
        return this.show
      }
    }
  }
}
</script>

<style lang="stylus">
.follow {
  display: flex;
  justify-content: center;
  padding: 0 10px 10px 10px;
  .qrCode {
    width: 100%;
    margin-top: 20px;
    .intro {
      padding: 0 15px;
    }
  }
}
 .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .block {
    width: 550px;
    background: #FFFFFF;
    box-shadow: 0px 0px 24px 0px rgba(3, 0, 26, 0.1);
    border-radius: 10px;
    padding: 30px 30px 60px 30px;
    .title {
      font-weight: bold;
      color: #333333;
      font-size: 34px;
    }
    .qrCode {
      text-align: center;
      padding: 0 30px;
      margin-top: 30px;
      .img {
        width: 100%;
      }
    }
    .desc {
      padding: 0 30px;
      color: #333333;
      font-size: 20px;
    }
  }
</style>